import { debug } from './theme/debug.js';
import { helpers } from './theme/helpers.js';

import { stickyHeader } from './theme/components/sticky-header.js';
import { viewport } from './theme/components/viewport.js';
import { animateText } from './theme/components/animate-text.js';
import { navigation } from './theme/components/navigation.js';
import { newsletter } from './theme/components/newsletter.js';
import { masonry } from './theme/components/masonry.js';
import { hamburger } from './theme/components/hamburger.js';
import { copyLink } from './theme/components/copy-link.js';
import { arrow } from './theme/components/arrow.js';
import { transitionNav } from './theme/components/transition-nav.js';
import { progress } from './theme/components/progress.js';
import { slider } from './theme/components/slider.js';
import { countLines } from './theme/components/count-lines.js';
import { search } from './theme/components/search.js';
import { lightbox } from './theme/components/lightbox.js';
import { map } from './theme/components/map.js';
import { banners } from './theme/components/banners.js';

window.theme = {
    globals: {
        enablePjax: true,
        isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
    },
    init: function () {
        var theme = this;

        viewport.init();
        stickyHeader.init();
        slider.init();
        animateText.init();
        navigation.init();
        newsletter.init();
        masonry.init();
        hamburger.init();
        copyLink.init();
        arrow.init();
        transitionNav.init();
        progress.init();
        countLines.init();
        search.init();
        lightbox.init();
        map.init();
        banners.init();

        $(document.body).addClass('loaded');

        if (theme.globals.isTouch === true) {
            $(document.body).addClass('touch-device');
        } else {
            $(document.body).addClass('pointer-device');
        }
    },
};

jQuery(document).ready(function ($) {
    theme.init();
});
